import * as React from "react"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { ChartData } from "react-chartjs-2"
import * as actions from "../../../actions"
import GeneralComponent from "./general-component"
import { ColorsHelper } from "../../../util/colors"
import * as _ from "lodash"

class GeneralContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { tableResData: [] }
    }
    componentDidMount() {
        if (!this.props.localAuthority && !this.props.tableResData) return
        this._updateData(this.props.tableResData, this.props.localAuthority, this.props.years)
    }
    componentWillReceiveProps(nextProps) {
        if (!nextProps.localAuthority && !nextProps.tableResData) return
        this._updateData(nextProps.tableResData, nextProps.localAuthority, nextProps.years)
    }

    render() {
        const tableResData = this.state.tableResData
        const years = this.props.years
        const chartData = this._getChartData(tableResData, years)
        return (
            <GeneralComponent
                chartData={chartData}
                tableResData={tableResData}
                loading={this.props.loading}
                years={years}
                singled={this.props.singled}
                localAuthorityId={this.props.localAuthority.id} />
        )
    }

    /**
     * @param {object[]} tableResData
     * @param {number[]} years
     *
     * @returns {ChartData}
     */
    _getChartData = (tableResData, years) => {
		/** @type {ChartData} */ const data = {}
        data.labels = years.map(year => year.toString())

        if (!tableResData || !tableResData.length) return data
        const colors = ColorsHelper.getEquidistantPastelColors(3, 30)

        data.datasets = [
            {
                borderColor: colors[0],
                data: data.labels.map(label => tableResData[0][label]),
                fill: false,
                label: tableResData[0].label
            },
            {
                borderColor: colors[1],
                data: data.labels.map(label => tableResData[1][label]),
                fill: false,
                label: tableResData[1].label
            },
            {
                borderColor: colors[2],
                data: data.labels.map(label => tableResData[2][label]),
                fill: false,
                label: tableResData[2].label
            }
        ]

        return data
    }

    _updateData = (tableResData, localAuthority, years) => {
        if (!localAuthority) return
        const results = localAuthority.results
        const rests = localAuthority.rests

        let sectionFonctionnement = tableResData[0]
        let sectionInvestissement = tableResData[1]
        if (!sectionFonctionnement || !sectionInvestissement) return

        years.forEach(y => {
            const year = y.toString()
            let resultFonctionnement = _.find(results, result => result.year === year - 1 && result.operation)
            let resultInvestissement = _.find(results, result => result.year === year - 1 && !result.operation)
            let restReceipt = _.find(rests, rest => rest.year === year - 1 && rest.receipt)
            let restExpense = _.find(rests, rest => rest.year === year - 1 && !rest.receipt)
            if (sectionFonctionnement[year] && resultFonctionnement) sectionFonctionnement[year] += resultFonctionnement.amount
            if (sectionInvestissement[year] && resultInvestissement) sectionInvestissement[year] += resultInvestissement.amount
            if (sectionInvestissement[year] && restReceipt) sectionInvestissement[year] += restReceipt.amount
            if (sectionInvestissement[year] && restExpense) sectionInvestissement[year] -= restExpense.amount
        })

        years.forEach(y => {
            const year = y.toString()
            if (!tableResData[2][year]) return
            tableResData[2][year] = sectionFonctionnement[year] + sectionInvestissement[year]
        })

        this.setState({ tableResData })
    }
}

const mapStateToProps = state => state
const mapDispatchToProps = (dispatch) => (
    { actions: bindActionCreators(actions, dispatch) }
);

export default connect(mapStateToProps, mapDispatchToProps)(GeneralContainer)


// WEBPACK FOOTER //
// ./src/component/summary/general/general-container.js